/* Maela product page: gallery, variant picker, add to cart, sticky bar, carousels, reveal. */
(function () {
  // Every mpd section includes this script; run it only once.
  if (window.mpdLoaded) return;
  window.mpdLoaded = true;
  document.documentElement.classList.add('mpd-js');

  var money = function (cents, fmt) {
    var n = (cents / 100).toFixed(2).split('.');
    var whole = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var str = n[1] === '00' ? whole : whole + ',' + n[1];
    return (fmt || '{{amount_with_comma_separator}} Kč').replace(/\{\{\s*\w+\s*\}\}/, str);
  };

  // Scroll-driven checks, batched to one per frame. Runs once immediately.
  var scrollFns = [];
  var ticking = false;
  var runScrollFns = function () {
    ticking = false;
    scrollFns.forEach(function (fn) { fn(); });
  };
  var onScroll = function (fn) { scrollFns.push(fn); fn(); };
  var schedule = function () {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(runScrollFns);
  };
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  window.addEventListener('load', schedule);

  function initGallery(root) {
    var track = root.querySelector('.mpd-gal__track');
    if (!track) return;
    var slides = track.children;
    var thumbs = root.querySelectorAll('.mpd-gal__thumb');
    var dots = root.querySelectorAll('.mpd-gal__dots i');
    var go = function (i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
    };
    var current = function () { return Math.round(track.scrollLeft / track.clientWidth); };
    track.addEventListener('scroll', function () {
      var i = current();
      thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
    }, { passive: true });
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    var prev = root.querySelector('.mpd-gal__nav--prev');
    var next = root.querySelector('.mpd-gal__nav--next');
    if (prev) prev.addEventListener('click', function () { go(current() - 1); });
    if (next) next.addEventListener('click', function () { go(current() + 1); });
    root.mpdShowImage = function (src) {
      var target = slides[0] && slides[0].querySelector('.mpd-vimg');
      if (!target || !src) return;
      target.removeAttribute('srcset');
      target.src = src;
      go(0);
    };
  }

  function initBuy(root) {
    var dataEl = root.querySelector('[data-mpd-product]');
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    var fmt = root.getAttribute('data-money-format');
    var state = { o1: data.selected[0], o2: data.selected[1] };
    var gal = root.querySelector('.mpd-gal');
    var btn = root.querySelector('[data-mpd-atc]');
    var err = root.querySelector('.mpd-atc__err');
    var sticky = document.querySelector('[data-mpd-sticky]');
    var stickyBtn = sticky && sticky.querySelector('[data-sticky-btn]');

    var find = function (o1, o2) {
      return data.variants.find(function (v) {
        return v.option1 === o1 && (data.options < 2 || v.option2 === o2);
      });
    };

    var render = function (swapImage) {
      root.querySelectorAll('[data-o1]').forEach(function (b) {
        b.classList.toggle('is-on', b.getAttribute('data-o1') === state.o1);
      });
      var label = root.querySelector('[data-o1-label]');
      if (label) label.textContent = state.o1;
      root.querySelectorAll('[data-o2]').forEach(function (card) {
        var v = find(state.o1, card.getAttribute('data-o2'));
        card.classList.toggle('is-on', card.getAttribute('data-o2') === state.o2);
        card.classList.toggle('is-off', !v || !v.available);
        card.setAttribute('aria-pressed', card.getAttribute('data-o2') === state.o2);
        if (!v) return;
        card.querySelector('[data-price]').textContent = money(v.price, fmt);
        var cmp = card.querySelector('[data-cmp]');
        var save = card.querySelector('[data-save]');
        if (cmp) cmp.textContent = v.compare_at_price > v.price ? money(v.compare_at_price, fmt) : '';
        if (save) {
          var s = v.compare_at_price > v.price ? Math.round((1 - v.price / v.compare_at_price) * 100) : 0;
          save.textContent = s ? '−' + s + ' %' : '';
          save.style.display = s ? '' : 'none';
        }
      });
      var v = find(state.o1, state.o2);
      if (v && btn) {
        btn.disabled = !v.available;
        btn.querySelector('[data-atc-label]').textContent = v.available ? btn.getAttribute('data-label') : 'Dočasně vyprodáno';
        if (stickyBtn) stickyBtn.disabled = !v.available;
        if (swapImage && v.image && gal && gal.mpdShowImage) gal.mpdShowImage(v.image);
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      return v;
    };

    root.querySelectorAll('[data-o1]').forEach(function (b) {
      b.addEventListener('click', function () { state.o1 = b.getAttribute('data-o1'); render(true); });
    });
    root.querySelectorAll('[data-o2]').forEach(function (c) {
      c.addEventListener('click', function () { state.o2 = c.getAttribute('data-o2'); render(true); });
      c.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); c.click(); }
      });
    });

    var add = function () {
      var v = find(state.o1, state.o2);
      if (!v || !v.available) return;
      err.textContent = '';
      btn.disabled = true;
      if (stickyBtn) stickyBtn.disabled = true;
      var drawer = document.querySelector('cart-drawer');
      var body = { items: [{ id: v.id, quantity: 1 }] };
      if (drawer && drawer.getSectionsToRender) {
        body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      }
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.j.description || res.j.message || 'Chyba');
          if (window.publish && window.PUB_SUB_EVENTS) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form' });
          // The drawer keeps its empty-cart layout (header and footer hidden) until this class goes,
          // exactly like the theme's own product form does it.
          if (drawer) drawer.classList.remove('is-empty');
          if (drawer && drawer.renderContents && res.j.sections) drawer.renderContents(res.j);
          else window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
        })
        .catch(function (e) { err.textContent = e.message; })
        .finally(function () {
          btn.disabled = false;
          if (stickyBtn) stickyBtn.disabled = false;
        });
    };
    if (btn) btn.addEventListener('click', add);
    if (sticky) {
      stickyBtn.addEventListener('click', add);
      onScroll(function () {
        var on = btn.getBoundingClientRect().bottom < 0;
        sticky.classList.toggle('is-on', on);
        document.documentElement.classList.toggle('mpd-sticky-on', on); // lifts the discount pill above the bar
      });
    }
    render(false);
  }

  function initScrollers() {
    document.querySelectorAll('[data-mpd-scroller]').forEach(function (wrap) {
      var track = wrap.querySelector('.mpd-scroll');
      if (!track) return;
      var step = function (dir) {
        var item = track.children[0];
        var w = item ? item.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
        track.scrollBy({ left: dir * w, behavior: 'smooth' });
      };
      var prev = wrap.querySelector('[data-prev]');
      var next = wrap.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
    });
  }

  function initReveal() {
    onScroll(function () {
      var limit = window.innerHeight * 0.9;
      document.querySelectorAll('.mpd-rv:not(.is-in)').forEach(function (e) {
        if (e.getBoundingClientRect().top < limit) e.classList.add('is-in');
      });
    });
  }

  function initScrollLinks() {
    document.querySelectorAll('a[href="#mpd-buy"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var t = document.getElementById('mpd-buy');
        if (!t) return;
        e.preventDefault();
        t.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  // iOS in Low Power Mode refuses autoplay; then show a play button instead of a frozen frame.
  function initVideos() {
    document.querySelectorAll('.mpd-video__frame').forEach(function (frame) {
      var v = frame.querySelector('video');
      if (!v || v.mpdInit) return;
      v.mpdInit = true;
      v.muted = true;
      var sync = function () { frame.classList.toggle('is-paused', v.paused); };
      var play = function () {
        var p = v.play();
        if (p && p.catch) p.catch(sync);
      };
      v.addEventListener('playing', sync);
      v.addEventListener('pause', sync);
      frame.addEventListener('click', function () { if (v.paused) play(); else v.pause(); });
      play();
    });
  }

  // Customer videos open in one shared lightbox, with sound, on top of the page.
  function initUgc() {
    if (window.mpdUgc) return;
    window.mpdUgc = true;
    var box, video;
    var close = function () {
      video.pause();
      video.removeAttribute('src');
      video.load();
      box.hidden = true;
      document.documentElement.classList.remove('mpd-lock');
    };
    document.addEventListener('click', function (e) {
      var card = e.target.closest && e.target.closest('[data-mpd-ugc]');
      if (!card || !card.getAttribute('data-mpd-ugc')) return;
      if (!box) {
        box = document.createElement('div');
        box.className = 'mpd-lb';
        box.setAttribute('role', 'dialog');
        box.setAttribute('aria-modal', 'true');
        box.innerHTML = '<video controls playsinline></video><button type="button" class="mpd-lb__x" aria-label="Zavřít">&times;</button>';
        document.body.appendChild(box);
        video = box.querySelector('video');
        box.addEventListener('click', function (ev) {
          if (ev.target === box || ev.target.closest('.mpd-lb__x')) close();
        });
        document.addEventListener('keydown', function (ev) {
          if (ev.key === 'Escape' && !box.hidden) close();
        });
      }
      video.src = card.getAttribute('data-mpd-ugc');
      box.hidden = false;
      document.documentElement.classList.add('mpd-lock');
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    });
  }

  function initHero(root) {
    if (root.mpdInit) return;
    root.mpdInit = true;
    var track = root.querySelector('.mpd-hero__track');
    var slides = track.children;
    var dots = root.querySelectorAll('.mpd-hero__dots button');
    var timer = null;
    var stop = function () { clearInterval(timer); timer = null; };
    var current = function () { return Math.round(track.scrollLeft / track.clientWidth); };
    var go = function (i) {
      var n = slides.length;
      track.scrollTo({ left: ((i + n) % n) * track.clientWidth, behavior: 'smooth' });
    };
    var sync = function () {
      var i = current();
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
    };
    track.addEventListener('scroll', sync, { passive: true });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { stop(); go(k); }); });
    var prev = root.querySelector('.mpd-hero__nav--prev');
    var next = root.querySelector('.mpd-hero__nav--next');
    if (prev) prev.addEventListener('click', function () { stop(); go(current() - 1); });
    if (next) next.addEventListener('click', function () { stop(); go(current() + 1); });
    var delay = parseInt(root.getAttribute('data-autoplay'), 10) * 1000;
    if (delay && slides.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      timer = setInterval(function () { if (!document.hidden) go(current() + 1); }, delay);
      track.addEventListener('pointerdown', stop, { passive: true });
      track.addEventListener('touchstart', stop, { passive: true });
    }
    sync();
  }

  // The theme's hamburger opens the picture-card menu instead of the theme's own drawer.
  function initMenu() {
    var menu = document.querySelector('[data-mpd-menu]');
    if (!menu || menu.mpdInit) return;
    menu.mpdInit = true;
    var open = function () {
      menu.hidden = false;
      document.documentElement.classList.add('mpd-lock');
      void menu.offsetWidth; // apply the closed position first so the panel slides in
      menu.classList.add('is-open');
    };
    var close = function () {
      menu.classList.remove('is-open');
      document.documentElement.classList.remove('mpd-lock');
      setTimeout(function () { if (!menu.classList.contains('is-open')) menu.hidden = true; }, 350);
    };
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('header-drawer .header__icon--menu');
      if (!t) return;
      e.preventDefault();
      e.stopPropagation();
      open();
    }, true);
    menu.querySelectorAll('[data-mpd-menu-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.classList.contains('is-open')) close();
    });
    document.addEventListener('shopify:section:select', function (e) { if (e.target.contains(menu)) open(); });
    document.addEventListener('shopify:section:deselect', function (e) { if (e.target.contains(menu)) close(); });
    // The card images are lazy inside a hidden menu, so they would pop in only after opening; fetch them once the page is idle.
    var warm = function () {
      setTimeout(function () {
        menu.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
      }, 1200);
    };
    if (document.readyState === 'complete') warm();
    else window.addEventListener('load', warm);
  }

  // Discount popup: opens once after a delay, then stays away for N days and leaves a small pill that reopens it.
  function initPop() {
    var pop = document.querySelector('[data-mpd-pop]');
    if (!pop || pop.mpdInit) return;
    pop.mpdInit = true;
    var teaser = document.querySelector('[data-mpd-teaser]');
    var safe = function (fn) { try { return fn(); } catch (e) { return null; } };
    var DAY = 86400000;
    var days = parseInt(pop.getAttribute('data-days'), 10) || 7;
    var delay = (parseInt(pop.getAttribute('data-delay'), 10) || 8) * 1000;
    var editor = window.Shopify && Shopify.designMode;
    var closedAt = parseInt(safe(function () { return localStorage.getItem('mpdPopClosed'); }), 10) || 0;
    var done = safe(function () { return localStorage.getItem('mpdPopDone'); }) === '1';
    // Any newsletter sign-up on the site counts: the shop adds customer_posted=true after a successful one.
    if (/[?&]customer_posted=true/.test(window.location.search)) {
      done = true;
      safe(function () { localStorage.setItem('mpdPopDone', '1'); });
    }

    var showTeaser = function () {
      if (!teaser) return;
      var dismissed = safe(function () { return sessionStorage.getItem('mpdTeaserX'); }) === '1';
      teaser.hidden = done || dismissed;
    };
    var open = function () {
      if (!document.contains(pop)) return;
      pop.hidden = false;
      document.documentElement.classList.add('mpd-lock');
      void pop.offsetWidth; // apply the closed state first so the box animates in
      pop.classList.add('is-open');
    };
    var close = function () {
      if (pop.hidden) return;
      pop.classList.remove('is-open');
      document.documentElement.classList.remove('mpd-lock');
      setTimeout(function () { if (!pop.classList.contains('is-open')) pop.hidden = true; }, 350);
      if (editor) return;
      safe(function () { localStorage.setItem('mpdPopClosed', String(Date.now())); });
      showTeaser();
    };

    pop.querySelectorAll('[data-mpd-pop-close]').forEach(function (b) { b.addEventListener('click', close); });
    // A sign-up anywhere on the page (popup or newsletter section) ends the popup and the pill for good.
    document.addEventListener('mpd:subscribed', function () {
      done = true;
      safe(function () { localStorage.setItem('mpdPopDone', '1'); });
      if (teaser) teaser.hidden = true;
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    // Links to "#mpd-pop" (e.g. the newsletter perk in the menu) open the popup.
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href*="#mpd-pop"]');
      if (!a || a.hash !== '#mpd-pop') return;
      e.preventDefault();
      open();
    });
    if (teaser) {
      teaser.querySelector('[data-mpd-teaser-open]').addEventListener('click', open);
      teaser.querySelector('[data-mpd-teaser-x]').addEventListener('click', function () {
        teaser.hidden = true;
        safe(function () { sessionStorage.setItem('mpdTeaserX', '1'); });
      });
    }

    if (editor) {
      document.addEventListener('shopify:section:select', function (e) { if (e.target.contains(pop)) open(); });
      document.addEventListener('shopify:section:deselect', function (e) { if (e.target.contains(pop)) close(); });
      return;
    }
    // Back from submitting this form: show the code or the error right away.
    if (window.location.hash === '#mpd-pop-form') { open(); return; }
    if (done) return;
    if (Date.now() - closedAt > days * DAY) setTimeout(function () { if (pop.hidden) open(); }, delay);
    else showTeaser();
  }

  // Sign-up forms inside [data-mpd-kl] send the e-mail straight to that Klaviyo list, which starts the welcome e-mails.
  // Without a list ID or key the form posts to the shop as usual.
  function initKlaviyo() {
    if (window.mpdKl) return;
    window.mpdKl = true;
    var keyOf = function (box) {
      var key = box.getAttribute('data-mpd-kl-key');
      if (key) return key;
      var script = document.querySelector('script[src*="klaviyo.com/onsite/js/"]');
      var m = script && script.src.match(/company_id=([^&]+)/);
      return m ? m[1] : '';
    };
    document.addEventListener('submit', function (e) {
      var box = e.target.closest && e.target.closest('[data-mpd-kl]');
      var list = box && box.getAttribute('data-mpd-kl');
      var key = box && keyOf(box);
      if (!list || !key) return;
      e.preventDefault();
      var form = e.target;
      var email = form.querySelector('input[type="email"]').value.trim();
      var btn = form.querySelector('[type="submit"]');
      var err = box.querySelector('[data-mpd-kl-err]');
      btn.disabled = true;
      if (err) err.hidden = true;
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(key), {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', revision: '2025-10-15' },
        body: JSON.stringify({ data: {
          type: 'subscription',
          attributes: {
            custom_source: box.getAttribute('data-mpd-kl-source') || 'Maela web',
            profile: { data: { type: 'profile', attributes: { email: email } } }
          },
          relationships: { list: { data: { type: 'list', id: list } } }
        } })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('Klaviyo ' + r.status);
          // Identified visitors no longer get Klaviyo's own sign-up forms.
          if (window.klaviyo && window.klaviyo.identify) window.klaviyo.identify({ email: email });
          box.querySelector('[data-mpd-kl-fields]').hidden = true;
          box.querySelector('[data-mpd-kl-done]').hidden = false;
          box.dispatchEvent(new CustomEvent('mpd:subscribed', { bubbles: true }));
        })
        .catch(function () { if (err) err.hidden = false; })
        .finally(function () { btn.disabled = false; });
    });
  }

  function initCopy() {
    if (window.mpdCopy) return;
    window.mpdCopy = true;
    document.addEventListener('click', function (e) {
      var c = e.target.closest && e.target.closest('[data-mpd-copy]');
      if (!c || !navigator.clipboard) return;
      navigator.clipboard.writeText(c.getAttribute('data-mpd-copy')).then(function () { c.classList.add('is-copied'); });
    });
  }

  function boot() {
    document.querySelectorAll('.mpd-gal').forEach(initGallery);
    document.querySelectorAll('[data-mpd-buy]').forEach(initBuy);
    document.querySelectorAll('[data-mpd-hero]').forEach(initHero);
    initScrollers();
    initReveal();
    initScrollLinks();
    initVideos();
    initUgc();
    initMenu();
    initPop();
    initKlaviyo();
    initCopy();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
